<template>
  <div class="generate-notes__component">
    <div class="generate-notes__box">
      <div class="header">
        <img
          src="../../../assets/images/course-card/close.png"
          alt=""
          @click="closeDrawer"
        />
      </div>
      <div class="main">
        <div class="qa-area" ref="qaArea">
          <div class="scroll-box" ref="scrollBox" @scroll="onHandleScroll">
            <div
              class="conversation-item"
              :ref="'conversationItem' + item.id"
              :class="{
                question: item.type === 'user',
                answer: item.type === 'system',
              }"
              v-for="(item, index) in chatList"
              :key="index"
            >
              <template v-if="item.status !== 'error'">
                <span
                  v-if="
                    item.type === 'system' &&
                    !item.content &&
                    replyStatus === 'loading'
                  "
                >
                  思考中...
                </span>
                <div class="content-wrap">
                  <ZxKatex
                    v-if="item.type === 'system'"
                    :content="dealContent(item.content, item.status)"
                  ></ZxKatex>
                  <div class="question" v-else>{{ item.content }}</div>
                </div>
                <!-- <span
                  class="loading-box"
                  v-if="item.type === 'system' && replyStatus === 'loading'"
                >
                  <span class="point"></span>
                  <span class="point"></span>
                  <span class="point"></span>
                </span> -->
              </template>
              <template v-else>
                <div class="error-box" @click="regenerate(item, index)">
                  <img
                    v-if="item.aiType === AI_TYPE_SUMMARY"
                    class="ai"
                    src="@saas/pages/assets/images/course-card/ai.png"
                    alt=""
                  />
                  <span>{{
                    item.aiType === AI_TYPE_SUMMARY
                      ? "AI笔记生成失败"
                      : "抱歉，未在当前视频查找到相关内容"
                  }}</span>
                  <img
                    v-if="item.aiType === AI_TYPE_SUMMARY"
                    class="fail"
                    src="@saas/pages/assets/images/course-card/fail.png"
                    alt=""
                  />
                </div>
              </template>

              <div class="message-handle" v-if="item.type === 'system'">
                <span
                  v-if="
                    index === chatList.length - 1 && item.status !== 'loading'
                  "
                  class="refresh-btn"
                  @click="regenerate(item, index)"
                >
                  <img
                    src="@saas/pages/assets/images/course-card/refresh.png"
                    alt=""
                  />
                  重新回答
                </span>
                <div class="right" v-if="item.status === 'success'">
                  <span class="good-btn" @click="handleGoodOrBad(item, 'top')">
                    <img
                      v-if="item.top !== 1"
                      src="@saas/pages/assets/images/course-card/good.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="@saas/pages/assets/images/course-card/good-click.png"
                      alt=""
                    />
                  </span>
                  <span class="bad-btn" @click="handleGoodOrBad(item, 'step')">
                    <img
                      v-if="item.step !== 1"
                      src="@saas/pages/assets/images/course-card/bad.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="@saas/pages/assets/images/course-card/bad-click.png"
                      alt=""
                    />
                  </span>
                  <span class="add-btn" @click="addToNote(item, index)">
                    <img
                      src="@saas/pages/assets/images/course-card/add.png"
                      alt=""
                    />
                    添加至笔记
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="more-btn"
            @click="onClickMore"
            v-if="!isScrollBottom && replyStatus === 'success'"
          >
            <img src="@saas/pages/assets/images/course-card/more.png" alt="" />
          </div>
          <div
            class="more-btn"
            @click="onClickMore"
            v-if="!isScrollBottom && replyStatus === 'loading'"
          >
            <img
              src="@saas/pages/assets/images/course-card/more-loading.gif"
              alt=""
            />
          </div>
        </div>
        <div class="input-area">
          <el-input
            type="textarea"
            :rows="1"
            :maxlength="100"
            autosize
            resize="none"
            placeholder="针对本节课程及笔记内容提问"
            v-model="questionValue"
            @keydown.native.space="onSpacekeydown"
            @keydown.native.enter.prevent.exact="clickSend"
            @keydown.native.shift.enter="onShiftEnter"
            @keydown.native.exact="onKeydown"
            @compositionstart.native="onCompositionstart"
            @compositionend.native="onCompositionend"
          >
          </el-input>
          <div class="handle-box">
            <img
              v-if="questionValue && replyStatus === 'success'"
              src="@saas/pages/assets/images/course-card/send.png"
              alt=""
              @click="clickSend"
            />

            <img
              v-else-if="replyStatus === 'loading'"
              src="@saas/pages/assets/images/course-card/break.png"
              alt=""
              @click="handleStop"
            />
            <img
              class="send-disabled"
              v-else
              src="@saas/pages/assets/images/course-card/send-disabled.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLessonQA, aiLessonMessageLike } from "@saas/service-api/src/course";
import {
  getToken,
  getRefreshToken,
  setToken,
  setRefreshToken,
} from "@saas/service-api/src/plugins/auth";
import { refreshToken } from "@saas/service-api/src/request";
// import WangEditor from "@saas/components/src/components/wang-editor/Index.vue";
import { v4 as uuidv4 } from "uuid";
import { marked } from "marked";
import ZxKatex from "@saas/components/src/components/zx-katex";
export default {
  components: {
    ZxKatex,
    // WangEditor,
  },
  props: {
    lessonInfo: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      questionValue: "",
      controller: null,
      // 回复状态
      replyStatus: "success", // loading 加载中，success 成功 ，error 错误
      chatList: [],
      qaList: [],
      isOpened: false,
      // 是否滚动到底部
      isScrollBottom: true,
      // 当前问题
      currentQuestionId: null,
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      isLoadingList: false,
      isListEnd: false,
      isInputChar: false,
    };
  },
  watch: {
    visible(val) {
      if (val && !this.isOpened) {
        this.isOpened = true;
        this.getLessonAiNoteList();
      }
    },
  },

  computed: {
    userTypes: () => {
      return {
        user: "user",
        system: "system",
        assistant: "assistant",
      };
    },
    AI_TYPE_SUMMARY: () => 2, // 总结
    AI_TYPE_QA: () => 1, // 问答
  },
  mounted() {},
  methods: {
    replaceMathDelimiters(str) {
      // 处理 \[ ... \] 块级公式
      return str.replace(/\\\[([\s\S]*?)\\\]/g, (match, content) => {
        return `$${content}$`;
      });
    },
    escapeLatexInString(input) {
      // 正则表达式模式匹配行内公式 $...$ 和块级公式 $$...$$
      const pattern = /(\$\$?)([^$]*?)\1/g;

      return input.replace(pattern, (match, delimiter, content) => {
        // 替换公式内容中的单斜杠为双斜杠
        const escapedContent = content.replace(/\\/g, "\\\\");

        // 返回替换后的完整公式
        return `${delimiter}${escapedContent}${delimiter}`;
      });
    },

    dealContent(content, status) {
      if (!content) {
        return "";
      }
      content = this.replaceMathDelimiters(content);
      content = this.escapeLatexInString(content);
      const str = status === "loading" ? "..." : "";
      content = content.replace(
        /^# (.*)/gm,
        (match) => `<h1>${match.slice(2)}</h1>`
      );
      return marked.parse(content + str).replace(/\n/g, "");
    },
    onSpacekeydown(event) {
      event.stopPropagation();
    },
    onKeydown(event) {
      const { keyCode } = event;
      if ([37, 39].includes(keyCode)) {
        // 这里可以添加自定义逻辑
        event.stopPropagation();
        return false; // 返回false阻止默认行为
      }

      // 其他情况返回true，保留默认行为
      return true;
    },
    onShiftEnter() {
      // 换行
      this.questionValue += "\n";
    },
    onCompositionstart() {
      console.log("输入开始");
      this.isInputChar = true;
    },
    onCompositionend() {
      console.log("输入结束");
      this.isInputChar = false;
    },
    closeDrawer() {
      this.$emit("closeDrawer");
    },
    // 点击发送
    clickSend() {
      if (this.isInputChar) {
        return;
      }
      // 去除前后空格
      if (this.replyStatus === "loading") {
        return;
      }
      const message = this.questionValue.trim();
      if (!message) {
        this.$message.error("请输入内容");
        return;
      }
      this.questionValue = "";
      this.replyStatus = "loading";
      const questionId = uuidv4();
      this.chatList.push(
        {
          type: this.userTypes.user,
          content: message,
          id: questionId,
          aiType: this.AI_TYPE_QA,
        },
        {
          type: this.userTypes.system,
          content: "",
          id: uuidv4(),
          top: 2,
          step: 2,
          aiType: this.AI_TYPE_QA,
          status: "loading",
        }
      );
      this.currentQuestionId = questionId;
      this.scrollToBottom();
      this.sendMessage(this.AI_TYPE_QA, message);
    },
    // 生成总结 // 总结只能在第一条
    createSummary() {
      this.chatList = [
        {
          type: this.userTypes.system,
          content: "",
          id: uuidv4(),
          top: 2,
          step: 2,
          status: "loading", //  loading 加载中，success 成功 ，error 错误
          aiType: this.AI_TYPE_SUMMARY, // 1 问答 2 总结
        },
      ];
      this.sendMessage(this.AI_TYPE_SUMMARY);
    },

    // 获取课时笔记列表
    getLessonAiNoteList() {
      if (this.isLoadingList || this.isListEnd) {
        return;
      }
      this.isLoadingList = true;
      getLessonQA({
        course_id: this.lessonInfo.course_id,
        lesson_id: this.lessonInfo.id,
        page_no: this.pageInfo.page,
        page_size: this.pageInfo.pageSize,
      })
        .then((res) => {
          if (res.code === 1) {
            const list = (res.data.list || []).reverse();
            this.qaList = res.data.list || [];
            const total = res.data.total;
            if (total === 0) {
              this.isListEnd = true;
              this.createSummary();
            } else {
              const dealList = list.map((item, index) => {
                return {
                  type: item.role,
                  content: item.message,
                  question: index > 0 ? list[index - 1].message : "",
                  id: item.id,
                  top: item.is_top || 2,
                  step: item.is_step || 2,
                  status: "success",
                  aiType: item.ai_type,
                  // aiType: item.summary_id
                  //   ? this.AI_TYPE_SUMMARY
                  //   : this.AI_TYPE_QA,
                };
              });
              this.chatList = [...dealList, ...this.chatList];
              if (total <= this.pageInfo.page * this.pageInfo.pageSize) {
                this.isListEnd = true;
              }
              if (this.pageInfo.page === 1) {
                this.$nextTick(() => {
                  this.$refs.scrollBox.scrollTo({
                    top: this.$refs.scrollBox.scrollHeight,
                  });
                });
              }
              this.pageInfo.page++;
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.isLoadingList = false;
        });
    },
    // 中止生成
    handleStop() {
      try {
        if (this.controller && this.controller.abort) {
          this.controller.abort();
          this.controller = null;
        }
      } catch (error) {
        console.error("stop replay>>>", error);
      }
      this.replyStatus = "success";
      this.chatList[this.chatList.length - 1].status = "success";
    },
    // 重新生成
    regenerate(item, index) {
      // 重新生成。 最后一条数据重置
      this.$set(this.chatList, this.chatList.length - 1, {
        type: this.userTypes.system,
        content: "",
        id: item.id,
        top: 2,
        step: 2,
        status: "loading",
        aiType: item.aiType,
      });
      const message =
        item.aiType === this.AI_TYPE_SUMMARY
          ? ""
          : this.chatList[index - 1].content;
      const id = String(item.id).indexOf("-") > 0 ? 0 : item.id;
      this.replyStatus = "loading";
      this.sendMessage(item.aiType, message, id);
    },
    // 添加至笔记
    addToNote(item, index) {
      const data = {
        type: item.aiType,
        answer: item.content,
      };
      if (index > 0) {
        data.question = this.chatList[index - 1].content;
      }
      this.$message.success("笔记添加成功");
      this.$emit("addToNote", data);
    },
    // 点赞或者踩
    handleGoodOrBad(item, type) {
      if (item.id) {
        const params = {
          message_id: item.id,
          top: type === "top" ? (item[type] === 1 ? 2 : 1) : item[type],
          step: type === "step" ? (item[type] === 1 ? 2 : 1) : item[type],
        };
        aiLessonMessageLike(params).then((res) => {
          if (res.code === 1) {
            item.top = res.data.top;
            item.step = res.data.step;
            this.$message.success("操作成功");
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.error("操作失败");
      }
    },
    // 发送信息 aitype 1 问答， 2 生成总结
    sendMessage(aiType = 1, message = "", id) {
      this.controller = new AbortController();
      const params = {
        course_id: this.lessonInfo.course_id,
        lesson_id: this.lessonInfo.id,
        message: message,
        ai_type: aiType,
      };
      if (id) {
        params.id = id;
      }
      const isPro = process.env.NODE_ENV === "production";
      const api =
        aiType === 1
          ? "/v1/course/sendAiLessonMessage"
          : "/v1/course/getAiLessonSummary";
      const proxy = isPro ? process.env.VUE_APP_ADMIN_API : "";
      this.replyStatus = "loading";
      fetch(proxy + api, {
        method: "POST",
        signal: this.controller.signal,
        credentials: "include",
        body: JSON.stringify(params),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      })
        .then(async (res) => {
          // console.log(res, ">>>>>>>>>>res");
          const utf8Decoder = new TextDecoder("utf-8");
          const stream = res.body.getReader();
          // console.log("stream>>>>>>>>>>>>", stream);

          let _this = this;
          await stream.read().then(function processResult(result) {
            // console.log("result>>>>>>>>>>>>", result);
            if (result.done) {
              // 处理完成，退出函数
              _this.replyStatus = "success";
              _this.chatList[_this.chatList.length - 1].status = "success";
              return;
            }
            const chunk = utf8Decoder.decode(result.value);
            const resArr = chunk.split("\n");
            // console.log("resArr>>>>>>>>>>>>", resArr);
            try {
              const resObj = JSON.parse(resArr[0]);
              if (resObj.code) {
                if (resObj.code !== 1) {
                  if (resObj.code === 10018) {
                    // token过期
                    refreshToken().then((tokenRes) => {
                      if (tokenRes.code === 1) {
                        setRefreshToken(tokenRes.data.refresh_token);
                        setToken(tokenRes.data.access_token);
                        _this.sendMessage(aiType, message, id);
                      }
                    });
                    return;
                  } else {
                    _this.$message.error(resObj.message);
                    _this.replyStatus = "error";
                    _this.chatList[_this.chatList.length - 1].status = "error";
                    return;
                  }
                } else {
                  const data = resObj.data;
                  _this.chatList[_this.chatList.length - 1].id = data.id;
                  _this.chatList[_this.chatList.length - 1].content =
                    data.content || data.message;
                  _this.replyStatus = "success";
                  _this.chatList[_this.chatList.length - 1].status = "success";
                  _this.scrollToBottom();
                  _this.currentQuestionId = null;
                }
              } else {
                // 正常
                resArr.forEach((item) => {
                  if (!item) return;
                  const itemObj = JSON.parse(item);
                  if (itemObj.content) {
                    _this.chatList[_this.chatList.length - 1].content +=
                      itemObj.content;
                  }
                });
                _this.scrollToBottom();
              }
            } catch (error) {
              console.log("error>>>>", error);
              _this.handleStop();
              _this.replyStatus = "error";
              _this.chatList[_this.chatList.length - 1].status = "error";
            }
            if (_this.replyStatus === "loading") {
              stream.read().then(processResult);
            }
          });
        })
        .catch((err) => {
          console.log("catch err>>>>", err);
          this.chatList[this.chatList.length - 1].status = "error";
          this.replyStatus = "error";
          this.handleStop();
          this.$message.error("网络异常，请检查网络");
        })
        .finally(() => {});
    },
    onHandleScroll() {
      // console.log(this.$refs.scrollBox.scrollTop);
      const scrollTop = this.$refs.scrollBox.scrollTop;
      if (scrollTop < 100) {
        // 加载数据
        this.getLessonAiNoteList();
      }
      this.isScrollBottom =
        this.$refs.scrollBox.scrollTop + this.$refs.scrollBox.clientHeight >=
        this.$refs.scrollBox.scrollHeight - 20;
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.isScrollBottom =
          this.$refs.scrollBox.scrollTop + this.$refs.scrollBox.clientHeight >=
          this.$refs.scrollBox.scrollHeight - 20;
        if (this.currentQuestionId) {
          const dom =
            this.$refs["conversationItem" + this.currentQuestionId][0];
          // 判断dom是否在scrollbox的顶部
          if (dom && dom.offsetTop <= this.$refs.scrollBox.scrollTop) {
            this.$refs.scrollBox.scrollTo({
              top: dom.offsetTop,
              behavior: "smooth",
            });
          } else {
            // 滚动到底部 带滚动效果
            this.$refs.scrollBox.scrollTo({
              top: this.$refs.scrollBox.scrollHeight,
              behavior: "smooth",
            });
          }
        } else {
          // 滚动到底部 带滚动效果
          this.$refs.scrollBox.scrollTo({
            top: this.$refs.scrollBox.scrollHeight,
            behavior: "smooth",
          });
        }
      });
    },
    onClickMore() {
      this.scrollToBottom();
    },
  },
};
</script>

<style lang="scss" scoped>
.generate-notes__component {
  --ai-note-bg: var(--mg-brand-soft-bg);
  --ai-note-panel-bg: rgba(255, 255, 255, 0.7);
  --ai-note-scrollbar: var(--mg-brand-soft-bg);
  --ai-note-message-bg: var(--mg-bg-card);
  --ai-note-message-border: var(--mg-border-subtle);
  --ai-note-control-bg: var(--mg-bg-card);
  --ai-note-control-hover-bg: var(--mg-control-hover-bg);
  --ai-note-text: var(--mg-text-primary);
  --ai-note-secondary: var(--mg-text-secondary);
  --ai-note-muted: var(--mg-text-muted);
  --ai-note-icon-filter: none;
  --ai-note-icon-muted-filter: grayscale(1) opacity(0.65);

  width: 100%;
  height: 100%;
  background: var(--ai-note-bg);

  html.dark & {
    --ai-note-bg: var(--mg-bg-surface);
    --ai-note-panel-bg: var(--mg-bg-card);
    --ai-note-scrollbar: var(--mg-control-hover-bg);
    --ai-note-message-bg: var(--mg-bg-elevated);
    --ai-note-message-border: var(--mg-border-subtle);
    --ai-note-control-bg: var(--mg-control-bg);
    --ai-note-control-hover-bg: var(--mg-control-hover-bg);
    --ai-note-text: var(--mg-text-primary);
    --ai-note-secondary: var(--mg-text-secondary);
    --ai-note-muted: var(--mg-text-muted);
    --ai-note-icon-filter: brightness(1.35);
    --ai-note-icon-muted-filter: grayscale(1) opacity(0.7);
  }

  .generate-notes__box {
    width: 100%;
    height: 100%;
    background: var(--ai-note-panel-bg);
    display: flex;
    flex-direction: column;
  }
  .header {
    width: 100%;
    height: 32px;
    min-height: 32px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    img {
      cursor: pointer;
      width: 20px;
      height: 20px;
      margin-right: 6px;
      filter: var(--ai-note-icon-filter);
    }
  }
  .main {
    padding: 14px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .qa-area {
      flex: 1;
      overflow-y: auto;
      position: relative;
      .scroll-box {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-thumb {
          background: var(--ai-note-scrollbar);
          border-radius: 2px;
        }
      }
      .conversation-item {
        word-break: break-all;
        font-weight: 400;
        font-size: 14px;
        color: var(--ai-note-text);
        margin-bottom: 8px;
        line-height: 22px;
        &.question {
          line-height: 20px;
          color: var(--ai-note-secondary);
          text-align: right;
          .content-wrap {
            text-align: left;
            padding: 4px 10px;
            border-radius: 4px;
            display: inline-block;
            background: var(--ai-note-message-bg);
            .question {
              white-space: pre-wrap;
            }
          }
        }

        .loading-box {
          display: inline-block;
          .point {
            width: 3px;
            height: 3px;
            border-radius: 3px;
            display: inline-block;
            background: var(--ai-note-secondary);
            margin-right: 3px;
          }
        }
        .message-handle {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 4px;
          .right {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }
          img {
            width: 14px;
            height: 14px;
            filter: var(--ai-note-icon-filter);
          }
          .good-btn,
          .bad-btn {
            margin-right: 8px;
            cursor: pointer;
          }
          .refresh-btn,
          .add-btn {
            height: 24px;
            background: var(--ai-note-control-bg);
            border-radius: 6px;
            border: 1px solid var(--ai-note-message-border);
            font-weight: 400;
            font-size: 11px;
            color: var(--ai-note-secondary);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 5px;
            cursor: pointer;
            &:hover {
              background: var(--ai-note-control-hover-bg);
              color: var(--ai-note-text);
            }
          }
        }
        .error-box {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          cursor: pointer;
          .ai {
            width: 22px;
            height: 22px;
          }
          .fail {
            width: 12px;
            height: 12px;
            margin-left: 4px;
          }
        }
      }
      .more-btn {
        width: 30px;
        height: 30px;
        position: absolute;
        left: 50%;
        bottom: 8px;
        transform: translateX(-50%);
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .input-area {
      width: 100%;
      min-height: 62px;
      max-height: 120px;
      background: var(--ai-note-control-bg);
      border-radius: 6px;
      border: 1px solid var(--ai-note-message-border);
      display: flex;
      flex-direction: column;
      .el-textarea ::v-deep {
        border: none;
        flex: 1;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-thumb {
          background: var(--ai-note-scrollbar);
          border-radius: 2px;
        }
        textarea {
          border: none;
          padding: 5px 8px;
          font-weight: 400;
          font-size: 14px;
          color: var(--ai-note-text);
          line-height: 22px;
          background: transparent;

          &::placeholder {
            color: var(--ai-note-muted);
          }
        }
      }
      .handle-box {
        height: 28px;
        min-height: 28px;
        padding: 4px 8px 0 8px;
        display: flex;
        justify-content: flex-end;
        img {
          width: 18px;
          height: 18px;
          cursor: pointer;
          filter: var(--ai-note-icon-filter);
        }
        .send-disabled {
          cursor: not-allowed;
          filter: var(--ai-note-icon-muted-filter);
        }
      }
    }
  }
}
</style>
